import { render, staticRenderFns } from "./growthModelParamDeviceManagement.vue?vue&type=template&id=8f2d2ba0&scoped=true"
import script from "./growthModelParamDeviceManagement.vue?vue&type=script&lang=js"
export * from "./growthModelParamDeviceManagement.vue?vue&type=script&lang=js"
import style0 from "./growthModelParamDeviceManagement.vue?vue&type=style&index=0&id=8f2d2ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2d2ba0",
  null
  
)

export default component.exports